module.exports = __webpack_public_path__ + "assets/img/Back_004.eac65147-ps.png";